import Base from './condition-base'
import renderFields from './flag-match.pug'

export default class FlagMatch extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
